export enum ProtectionKey {
  HAIL = "hail",
  WIND = "wind",
  HEAT = "heat",
  DROUGHT = "drought",
  FROST = "frost",
  CONTAMINATING_RAIN = "contaminatingRain",
  LEACHING_RAIN = "leachingRain",
}
